/** @format */

import { request } from 'src/utils'

interface BackData {
  code?: number | string
  data?: any
  message?: string
}

export const API = {
  GetEventPolicy: '/monitor/?Action=DescribeEventPolicyList&Version=2021-01-01', // 获取事件策略列表
  GetListSysEvents: '/monitor/?Action=ListSysEvents&Version=2021-01-01', // 获取系统事件
  CreateEventPolicy: '/monitor/?Action=CreateEventPolicy&Version=2021-01-01', // 创建事件告警策略
  ModifyEventPolicy: '/monitor/?Action=ModifyEventPolicy&Version=2021-01-01', // 修改事件告警策略
  DeleteEventPolicy: '/monitor/?Action=DeleteEventPolicys&Version=2021-01-01', // 删除事件告警策略
  EnableEventPolicy: '/monitor/?Action=EnableEventPolicys&Version=2021-01-01', // 启用事件告警策略
  DisableEventPolicy: '/monitor/?Action=DisableEventPolicys&Version=2021-01-01', // 禁用事件告警策略
  GetInstance: '/monitor/?Action=DescribeEventPolicyResources&Version=2021-01-01',

  ModifyPolicyName: '/monitorapi/policys/v2/ModifyPolicyName', //修改阈值告警名称
  SetPolicyAsDefault: '/monitorapi/policys/v2/SetPolicyAsDefault', //修改默认阈值告警策略
  CancelPolicyDefault: '/monitor/?Action=CancelPolicyDefault&Version=2021-01-01', // 取消默认阈值告警策略
  EnableAlarmPolicy: '/monitor/?Action=EnableAlarmPolicy&Version=2021-01-01', // 启动阈值告警策略
  DisableAlarmPolicy: '/monitor/?Action=DisableAlarmPolicy&Version=2021-01-01', // 禁用阈值告警策略
  GetTacticsPolicyDetail: '/monitor/?Action=DescribeThresholdPolicy&Version=2021-01-01', // 获取阈值告警详情
  // eslint-disable-next-line max-len
  GetPolicyInstances: '/monitor/?Action=DescribeThresholdPolicyResources&Version=2021-01-01', // 获取阈值告警策略下所选实例
  GetPolicyList: '/monitor/?Action=DescribeAlarmPolicyList&Version=2021-01-01', // UIC 获取阈值告警策略列表
  CreatePolicy: '/monitor/?Action=CreateAlarmPolicy&Version=2021-01-01', // 创建阈值告警策略
  ModifyAlarmPolicy: '/monitor/?Action=ModifyAlarmPolicy&Version=2021-01-01', // 修改阈值告警策略
  DeleteAlarmPolicy: '/monitor/?Action=DeleteAlarmPolicy&Version=2021-01-01', // 删除阈值告警策略
  GetProductList: '/monitor/?Action=DescribeMonitorProductList&Version=2021-01-01' // 获取产品列表UIC接口
}

// 生成请求参数
function generateOps(method, data) {
  switch (method) {
    case 'create':
      return {
        method: 'post',
        url: API.CreateEventPolicy,
        data: data
      }
    case 'delete':
      return {
        method: 'post',
        url: API.DeleteEventPolicy,
        data: data
      }
    case 'modify':
      return {
        method: 'post',
        url: API.ModifyEventPolicy,
        data: data
      }
    case 'getPolicy':
      return {
        method: 'get',
        url: API.GetEventPolicy,
        data: data ? data : {}
      }
    case 'enable':
      return {
        method: 'post',
        url: API.EnableEventPolicy,
        data: data
      }
    case 'disable':
      return {
        method: 'post',
        url: API.DisableEventPolicy,
        data: data
      }
    case 'getinstance':
      return {
        method: 'get',
        url: API.GetInstance,
        data: data
      }
    default:
      return null
  }
}

export const GetPolicyInstances = data => {
  return request(API.GetPolicyInstances, { method: 'get', data })
}

export const GetTacticsPolicyDetail = data => {
  return request(API.GetTacticsPolicyDetail, {
    method: 'get',
    data
  })
}

export const EditEnablePolicy = (enabled: boolean, data) => {
  return request(enabled ? API.EnableAlarmPolicy : API.DisableAlarmPolicy, {
    method: 'POST',
    data
  })
}

export const HandleDealPolicy = options => {
  const { method, data = undefined } = options
  const params = generateOps(method, data)
  return new Promise((resolve: (value: BackData) => void, reject) => {
    request(params, method).then(res => {
      resolve(res)
    })
  })
}

// 删除告警事件
export const DeleteEventPolicy = (policyNames: string[]) => {
  return new Promise<BackData>((resolve, reject) => {
    request(API.DeleteEventPolicy, {
      method: 'post',
      data: {
        PolicyNames: policyNames
      }
    }).then(res => {
      resolve(res)
    })
  })
}
// 启用告警事件
export const EnableEventPolicy = (policyNames: string[]) => {
  return new Promise<BackData>(resolve => {
    request(API.EnableEventPolicy, {
      method: 'post',
      data: {
        PolicyNames: policyNames
      }
    }).then(res => {
      resolve(res)
    })
  })
}

// 禁用事件告警
export const DisableEventPolicy = (policyNames: string[]) => {
  return new Promise<BackData>(resolve => {
    request(API.DisableEventPolicy, {
      method: 'post',
      data: {
        PolicyNames: policyNames
      }
    }).then(res => {
      resolve(res)
    })
  })
}
/**
 * 创建阈值告警策略
 * @param params
 * @returns 
 * {
    "requestId": "Test-Local-12345",
    "code": 0,
    "message": "请求成功",
    "policyId": 1
    }
 */
export const CreatePolicy = async params => {
  return request(API.CreatePolicy, { method: 'post', data: { ...params } })
}

// 修改阈值策略
export const ModifyAlarmPolicy = async params => {
  return request(API.ModifyAlarmPolicy, { method: 'post', data: { ...params } })
}

// 删除阈值策略
export const DeleteAlarmPolicy = async params => {
  return request(API.DeleteAlarmPolicy, { method: 'post', data: { ...params } })
}

/**
 * 获取产品列表（非授权）UIC
 */
export const GetProductList = () => {
  return new Promise<BackData>(resolve => {
    request(API.GetProductList, {
      method: 'get'
    }).then(res => {
      resolve(res)
    })
  })
}

// 获取事件列表
export const GetListSysEvents = async params => {
  return request(API.GetListSysEvents, { method: 'get', data: { ...params } })
}

// 获取阈值告警列表
export const GetPolicyList = async params => {
  return request(API.GetPolicyList, { method: 'get', data: { ...params } })
}

// 获取事件告警列表
export const GetEventPolicy = async params => {
  return request(API.GetEventPolicy, { method: 'get', data: { ...params } })
}
